import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate, useLocation } from 'react-router-dom';
import logo from '../assets/logo.png';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const menuRef = useRef(null);
  const buttonRef = useRef(null);

  // Close menu on outside click
  useEffect(() => {
    if (!menuOpen) return;
    const handleClickOutside = (event) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [menuOpen]);

  const handleScroll = (id) => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 100);
    } else {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
    setMenuOpen(false);
  };

  return (
    <nav className="w-full bg-white shadow flex items-center justify-between px-8 py-4 relative">
      {/* Left: Logo and Brand */}
      <div className="flex items-center space-x-3">
        <Link to="/" className="flex items-center space-x-3">
          <img src={logo} alt="Tieup Solutions Logo" className="h-9 w-24 object-contain" />
          <span className="ml-4 text-2xl font-extrabold text-black tracking-tight">ShuttleClash-2025</span>
        </Link>
        {/* Venue and Category links next to title (desktop only) */}
        <div className="hidden md:flex items-center space-x-8 ml-8">
          <button onClick={() => handleScroll('venue')} className="text-lg text-gray-800 font-medium hover:text-red-600 bg-transparent border-none cursor-pointer">Venue</button>
          <button onClick={() => handleScroll('category')} className="text-lg text-gray-800 font-medium hover:text-red-600 bg-transparent border-none cursor-pointer">Category</button>
        </div>
      </div>
      {/* Right: Register Button (desktop only) */}
      <div className="hidden md:flex items-center">
        <button
          onClick={() => handleScroll('register-form')}
          className="bg-red-500 hover:bg-red-600 text-white font-semibold rounded-md px-6 py-2 text-lg shadow transition"
        >
          Register Now
        </button>
      </div>
      {/* Hamburger for mobile */}
      <div className="md:hidden flex items-center relative">
        <button
          ref={buttonRef}
          onClick={() => setMenuOpen((prev) => !prev)}
          className="text-gray-800 focus:outline-none"
          aria-label="Toggle menu"
        >
          <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" /></svg>
        </button>
        {/* Mobile menu */}
        {menuOpen && (
          <div ref={menuRef} className="absolute top-full right-0 mt-2 w-48 bg-white rounded-lg shadow-lg flex flex-col z-50 border border-gray-100 max-h-96 overflow-y-auto">
            <button onClick={() => handleScroll('venue')} className="px-6 py-3 text-left text-gray-800 hover:bg-gray-100 border-b border-gray-100">Venue</button>
            <button onClick={() => handleScroll('category')} className="px-6 py-3 text-left text-gray-800 hover:bg-gray-100 border-b border-gray-100">Category</button>
            <button onClick={() => handleScroll('register-form')} className="px-6 py-3 text-left text-white bg-red-500 hover:bg-red-600 rounded-b-lg">Register Now</button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;